import { combineReducers } from 'redux';
import nav from './nav/nav.js';
import general from './general/general.js';
import notification from './notification/notification.js';
import workstation from './workstation/workstation.js';

const rootReducer = combineReducers({
  nav,
  workstation,
  general,
  notification
});

// const rootReducer = (initialState, state,action) => {
  
//     state = initialState;
// }

export default rootReducer;